import React, { useState, useEffect } from 'react';

export function Group({ children }) {
  return (
    <>
      {children}
    </>
  );
}